export default __webpack_public_path__ + "static/media/revicon3.75c551f9.svg";